import * as _ from "lodash";
import { IHaveSimulationCollection } from "../PA.Simulation.Core/PA.Simulation.IF.Aspects";
import {
    WB_CustomerHierarchyRow,
    WB_EntityRow,
    WB_PeriodHierarchyRow, WB_ProductHierarchyRow, WB_SalesOrgRow,
    WB_SimulationRow
} from "../PA.Core/PAdbSchemaRows";
import { BehaviorSubject } from "rxjs";
import { IMessageProvider } from "../PA.Core/PA.Core.IF.Basic";
import { MessageProvider } from "../PA.Core/Basic/Messages";
import { PAdbContext } from "../PA.Core/PAdbContext";
import { ExceptionMessage_restate } from "../PA.Core/Basic/MessageUtils";
import {
    esWB_Customer_Hierarchy,
    esWB_Entity,
    esWB_Period_Hierarchy,
    esWB_Product_Hierarchy, esWB_Published_Model,
    esWB_SalesOrg, esWB_Simulation
} from "../PA.Core/PAdbSchema";
import { PASearch } from "../PA.Core/PASearch";


export class SimulationCollection
    implements
    IHaveSimulationCollection
{
    private dbContext: PAdbContext
    private _wbSalesOrgId: number
    private _wbEntityIdCustomer: number
    private _wbEntityIdProduct: number
    private _wbEntityIdPeriod: number
    private _wbCustHId: number
    private _wbPrdHId: number
    private _wbPeriodHId: number
    private _arrWbSimulationIds: number[]

    private _bLoaded: boolean
    private _LoadMessageProvider: MessageProvider;

    private salesOrg: WB_SalesOrgRow;

    private customerEntity: WB_EntityRow;
    private customerHierarchy: WB_CustomerHierarchyRow;

    private productEntity: WB_EntityRow;
    private productHierarchy: WB_ProductHierarchyRow;

    private periodEntity: WB_EntityRow;
    private periodHierarchy: WB_PeriodHierarchyRow;

    private bScopeIncludesAltHierarchy: boolean
    private _SimulationsAll: WB_SimulationRow[]

    private _Simulations: WB_SimulationRow[]
    private _OnSimulationCollectionChanged: BehaviorSubject<IHaveSimulationCollection>

    constructor(options: {
                    dbContext?: PAdbContext,
                    bScopeIncludesAltHierarchy?: boolean
                })
    {
        const opts = options || {}

        this.dbContext = opts.dbContext
        if(_.isEmpty(this.dbContext))
            this.dbContext = new PAdbContext()

        this._bLoaded = false
        this._wbSalesOrgId = 0
        this._wbEntityIdCustomer = 0
        this._wbEntityIdProduct = 0
        this._wbEntityIdPeriod = 0
        this._wbCustHId = 0
        this._wbPrdHId = 0
        this._wbPeriodHId = 0
        this._arrWbSimulationIds = []

        this._Simulations = []
        this._SimulationsAll = []
        this._LoadMessageProvider = new MessageProvider()
        this._OnSimulationCollectionChanged = new BehaviorSubject<IHaveSimulationCollection>(this)
        this.bScopeIncludesAltHierarchy = !! opts.bScopeIncludesAltHierarchy
    }

    get bLoaded(): boolean { return this._bLoaded }

    async  setScope(wbSalesOrgId: number,
                    wbEntityIdCustomer: number,
                    wbEntityIdProduct: number,
                    wbEntityIdPeriod: number,
                    wbCustHId: number,
                    wbPrdHId: number,
                    wbPeriodHId: number,
                    wbSimulationIds?: number[]): Promise<void>
    {
        const self = this

        try {
            self._bLoaded = false
            self._wbSalesOrgId = wbSalesOrgId
            self._wbEntityIdCustomer = wbEntityIdCustomer
            self._wbEntityIdProduct = wbEntityIdProduct
            self._wbEntityIdPeriod = wbEntityIdPeriod
            self._wbCustHId = wbCustHId
            self._wbPrdHId = wbPrdHId
            self._wbPeriodHId = wbPeriodHId
            self._arrWbSimulationIds = wbSimulationIds || []

            self._Simulations = []
            self._SimulationsAll = []

            const tasks: Promise<any>[] = []

            tasks.push(this.dbContext.find(esWB_SalesOrg, self._wbSalesOrgId).then((a: WB_SalesOrgRow) => { self.salesOrg = a}))
            tasks.push(this.dbContext.find(esWB_Entity, self._wbEntityIdCustomer).then((a: WB_EntityRow) => { self.customerEntity = a}))
            tasks.push(this.dbContext.find(esWB_Entity, self._wbEntityIdProduct).then((a: WB_EntityRow) => { self.productEntity = a}))
            tasks.push(this.dbContext.find(esWB_Entity, self._wbEntityIdPeriod).then((a: WB_EntityRow) => { self.periodEntity = a}))
            tasks.push(this.dbContext.find(esWB_Customer_Hierarchy, self._wbCustHId).then((a: WB_CustomerHierarchyRow) => { self.customerHierarchy = a}))
            tasks.push(this.dbContext.find(esWB_Product_Hierarchy, self._wbPrdHId).then((a: WB_ProductHierarchyRow) => { self.productHierarchy = a}))
            tasks.push(this.dbContext.find(esWB_Period_Hierarchy, self._wbPeriodHId).then((a: WB_PeriodHierarchyRow) => { self.periodHierarchy = a}))
            await Promise.all(tasks)

            // TODO: Get All available Simulations
            // Use search service to find available Simulations in this scope
            // Find the Published Models at this entity Level
            const arrWbPMIds: number[] = _.map(await PASearch.find(esWB_Published_Model,
                    {where: {WB_SALESORG_ID: self._wbSalesOrgId,
                                                WB_ENTITY_ID_CUSTOMER: self._wbEntityIdCustomer,
                                                WB_ENTITY_ID_PRODUCT: self._wbEntityIdProduct,
                                                WB_ENTITY_ID_PERIOD: self._wbEntityIdPeriod,
                                                DELETED_IND: {neq: '1'}
                    }},undefined, [], 0,['WB_PUBLISHED_MODEL_ID']),
                (a) => a.WB_PUBLISHED_MODEL_ID)

            // Find the Simulations in Published Model/ and Same Hierarchies
            const sims: WB_SimulationRow[] = await self.dbContext.findAll(esWB_Simulation, {
                where: {WB_SALESORG_ID: self._wbSalesOrgId,
                        WB_PUBLISHED_MODEL_ID: {inq: arrWbPMIds},
                        WB_CUSTH_ID: self._wbCustHId,
                        WB_PRDH_ID: self._wbPrdHId,
                        WB_PERIODH_ID: self._wbPeriodHId,
                        DELETED_IND: {neq: '1'}}})

            self._SimulationsAll = sims

            self._bLoaded = true

            if(!_.isEmpty(self._arrWbSimulationIds))
                await self.syncSimulations(self._arrWbSimulationIds)

            self.OnSimulationCollectionChanged.next(self)

        } catch (e) {
            ExceptionMessage_restate(self._LoadMessageProvider, e)
        }
    }

    get LoadMessageProvider(): IMessageProvider { return this._LoadMessageProvider }

    get SalesOrg(): WB_SalesOrgRow { return this.salesOrg }

    get CustomerEntity(): WB_EntityRow { return this.customerEntity }
    get CustomerHierarchy(): WB_CustomerHierarchyRow { return this.customerHierarchy }

    get ProductEntity(): WB_EntityRow { return this.productEntity }
    get ProductHierarchy(): WB_ProductHierarchyRow { return this.productHierarchy }

    get PeriodEntity(): WB_EntityRow { return this.periodEntity }
    get PeriodHierarchy(): WB_PeriodHierarchyRow { return this.periodHierarchy }

    get SimulationsAll(): WB_SimulationRow[] { return this._SimulationsAll }

    get Simulations(): WB_SimulationRow[] { return this._Simulations }

    async addSimulation(wbSimulationId: number): Promise<void> {
        const self = this

        // Check if it's already in list
        let dctSim = _.keyBy(self._Simulations, (a) => a.cif.WB_SIMULATION_ID)
        if(wbSimulationId in dctSim)
            return

        const sims = _.filter(self.SimulationsAll, (a) => a.cif.WB_SIMULATION_ID == wbSimulationId)
        _.forEach(sims, (a) => {
            self._Simulations.push(a)
        })
        self.OnSimulationCollectionChanged.next(self)
    }

    async removeSimulation(wbSimulationId: number): Promise<void> {
        const self = this

        _.remove(self._Simulations, (a) => a.cif.WB_SIMULATION_ID == wbSimulationId)
        self.OnSimulationCollectionChanged.next(self)
    }

    async syncSimulations(arrWbSimulationId: number[]): Promise<void> {
        const self = this

        const arrExisting: number[] = _.map(self.Simulations, (a) => a.cif.WB_SIMULATION_ID)
        const dctAll = _.keyBy(self.SimulationsAll, (a) => a.cif.WB_SIMULATION_ID)

        const itemsToAdd = _.difference(arrWbSimulationId, arrExisting)
        const itemsToRemove = _.difference(arrExisting, arrWbSimulationId)

        for (const wbId of itemsToAdd) {
            if (wbId in dctAll)
               await self.addSimulation(wbId);
        }

        for (const wbId of itemsToRemove)
            await self.removeSimulation(wbId)

    }

    get OnSimulationCollectionChanged(): BehaviorSubject<IHaveSimulationCollection> {
        return this._OnSimulationCollectionChanged
    }

}


